module.exports = __webpack_public_path__ + "img/razi-logo-v2.72ea1591.png";